const PayloadComponent = ({ formattedJSON }) => {
  return (
    <div>
      <pre>{JSON.stringify(formattedJSON, null, 2)}</pre>
    </div>
  )
}

export default PayloadComponent